import { render } from "./NotificationElement.vue?vue&type=template&id=ce76439a&scoped=true&ts=true"
import script from "./NotificationElement.vue?vue&type=script&lang=ts"
export * from "./NotificationElement.vue?vue&type=script&lang=ts"

import "./NotificationElement.vue?vue&type=style&index=0&id=ce76439a&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce76439a"]])

export default __exports__